import { render, staticRenderFns } from "./NotificationBellIcon.vue?vue&type=template&id=014e08c6&scoped=true"
import script from "./NotificationBellIcon.vue?vue&type=script&lang=js"
export * from "./NotificationBellIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014e08c6",
  null
  
)

export default component.exports